 /*******************操作日志***************/
 export default [{
   path: "/journal",
   name: "操作日志"
 }]
